import React, { Fragment, } from 'react';
import PropTypes from 'prop-types';
import { useHeaderLevel, LevelProvider, } from './LevelContext';

Section.propTypes = {
  /** The Sections children nodes   */
  children: PropTypes.node,
  /** Should the Section Render as a react Fragment?   */
  isFragment: PropTypes.bool,
  /** The HTML tag to render the `<Section />` as */
  tagName: PropTypes.string,
};

Section.defaultProps = {
  children: null,
  isFragment: false,
  tagName: 'section',
};

export default function Section({ children, isFragment, tagName, ...props }) {
  const level = useHeaderLevel();
  const Tag = isFragment ? Fragment : tagName;

  return (
    <LevelProvider value={level + 1}>
      <Tag {...(isFragment ? {} : props)}>{children}</Tag>
    </LevelProvider>
  );
}
